import { render, staticRenderFns } from "./dubang.vue?vue&type=template&id=746c0bbe&scoped=true"
import script from "./dubang.vue?vue&type=script&lang=js"
export * from "./dubang.vue?vue&type=script&lang=js"
import style0 from "./dubang.vue?vue&type=style&index=0&id=746c0bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c0bbe",
  null
  
)

export default component.exports